import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import { PRECONNECTS } from '../constants';

// Returns preconnects from Firestore, falling back to constants if collection is empty
export function usePreconnects() {
  const [preconnects, setPreconnects] = useState(PRECONNECTS);

  useEffect(() => {
    const q = query(collection(db, 'preconnects'), orderBy('order', 'asc'));
    return onSnapshot(q, (snap) => {
      setPreconnects(snap.empty ? PRECONNECTS : snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
  }, []);

  return preconnects;
}
